import React from "react"
import CombinedBitRow from "../CombinedBitRow"
import { getBitValueFromHex } from '../BitValueCalculator'
import { getCombinedMeaning, getCvmConditionMeaning, getCvmResultMeaning } from '../CombinedMeaningCalculator'
import { renderNormalRow } from './NormalRowRenderer'


export const renderCvmResultsByte1Rows = (rows, byteIndex, builderData, currentHexValue, handleCellClick) => {
  const allRows = [];
  

  const bit8Row = rows.find(r => r.bit === 8);
  if (bit8Row) {
    allRows.push(renderNormalRow(bit8Row, byteIndex, true, handleCellClick));
  }
  
  const bit7Row = rows.find(r => r.bit === 7);
  if (bit7Row) {
    const bit7Value = getBitValueFromHex(byteIndex, 7, currentHexValue, 'cvmResults');
    const staticTexts = builderData?.staticTexts;
    const dynamicMeaning = bit7Value 
      ? staticTexts?.bit7When1 || "Apply succeeding CV Rule if this CVM is unsuccessful"
      : staticTexts?.bit7When0 || "Fail cardholder verification if this CVM is unsuccessful";
    
    allRows.push(renderNormalRow({...bit7Row, value: bit7Value, meaning: dynamicMeaning}, byteIndex, true, handleCellClick));
  }

  if (builderData?.method?.bitsRange) {
    const combinedBits = [];
    for (let bit = 6; bit >= 1; bit--) {
      combinedBits.push({
        bit: bit,
        value: getBitValueFromHex(byteIndex, bit, currentHexValue, 'cvmResults')
      });
    }
    const combinedMeaning = getCombinedMeaning('6-1', 'cvmResults', byteIndex, builderData, currentHexValue);
    
    allRows.push(
      <CombinedBitRow
        key="combined-6-1"
        byteIndex={byteIndex}
        bits={combinedBits}
        meaning={combinedMeaning}
        onBitToggle={handleCellClick}
      />
    );
  }
  
  return allRows;
}

export const renderCvmResultsByte2Rows = (byteIndex, builderData, currentHexValue, handleCellClick) => {
  const allRows = [];
  
  const combinedBits = [];
  for (let bit = 8; bit >= 1; bit--) {
    combinedBits.push({
      bit: bit,
      value: getBitValueFromHex(byteIndex, bit, currentHexValue, 'cvmResults')
    });
  }
  
  const conditionMeaning = getCvmConditionMeaning(currentHexValue, builderData);
  
  allRows.push(
    <CombinedBitRow
      key="combined-byte2"
      byteIndex={byteIndex}
      bits={combinedBits}
      meaning={conditionMeaning}
      onBitToggle={handleCellClick}
      title="CVM Condition (8 bits)"
    />
  );
  
  return allRows;
}

export const renderCvmResultsByte3Rows = (byteIndex, builderData, currentHexValue, handleCellClick) => {
  const allRows = [];
  
  const combinedBits = [];
  for (let bit = 8; bit >= 1; bit--) {
    combinedBits.push({
      bit: bit,
      value: getBitValueFromHex(byteIndex, bit, currentHexValue, 'cvmResults')
    });
  }
  
  const resultMeaning = getCvmResultMeaning(currentHexValue, builderData);
  
  allRows.push(
    <CombinedBitRow
      key="combined-byte3"
      byteIndex={byteIndex}
      bits={combinedBits}
      meaning={resultMeaning}
      onBitToggle={handleCellClick}
      title="CVM Result (8 bits)"
    />
  );
  
  return allRows;
}
